import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ng-casto-appointment-link',
  templateUrl: './appointment-link.component.html',
})
export class AppointmentLinkComponent {
  /** le lien vers la prise de rendez-vous */
  appointmentLink: SafeResourceUrl;

  constructor(
    public modalService: ModalService,
    sanitizer: DomSanitizer
  ) {
    this.appointmentLink = sanitizer.bypassSecurityTrustResourceUrl(this.modalService.currentDatas.appointmentLink);
  }
}
